
import BaseButton from 'JS/components/BaseButton.vue';
import Icon from 'JS/components/Icon.vue';
import Modal from 'JS/components/Modal.vue';
import { ComponentPublicInstance, defineComponent, nextTick, onMounted, onUnmounted, PropType, ref, watch } from 'vue';
import { getIntialFocusElement } from 'JS/utilities/dom';

export default defineComponent({
	name: 'ActionModal',
	components: {
		Modal,
		BaseButton,
		Icon,
	},
	props: {
		title: { type: String, required: false, default: '' },
		unclosable: { type: Boolean, required: false, default: false },
		loading: { type: Boolean },
		variant: { type: String as PropType<'normal' | 'centered'>, default: 'normal' },
	},
	setup(props, { emit }) {
		const el = ref<ComponentPublicInstance<typeof Modal> | null>(null);

		onMounted(() => {
			nextTick(() => getIntialFocusElement(el.value?.$el)?.focus());
		});

		const previouslyFocusedElement = document.activeElement as HTMLElement;
		onUnmounted(() => previouslyFocusedElement?.focus());

		let focusOnLoad: HTMLElement | null = null;
		watch(() => props.loading, isLoading => {
			if (isLoading) {
				focusOnLoad = document.activeElement as HTMLElement;
			} else {
				if (focusOnLoad) {
					nextTick(() => {
						focusOnLoad?.focus();
					});
				}
			}
		});

		return {
			el,
			close() {
				if (props.unclosable) {
					return;
				}

				emit('cancel');
			}
		};
	}
});
